module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"eventSearch":"Search by event name","pointOfSale":"Filter by restaurant","eventType":"Filter by event type"},"es":{"eventSearch":"Buscar por nombre de evento","pointOfSale":"Filtrar por restaurante","eventType":"Filtrar por tipo de evento"}}')
  delete Component.options._Ctor
}
